<template>
  <el-dialog
    v-model="dialogVisible"
    :close-on-click-modal="false"
    title="坐席状态"
    width="800"
    :before-close="handleClose"
  >
    <el-scrollbar height="800">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{
  'background-color': '#eef5ff',
  'color': '#333',
  'font-size':'18px'

        }"
      >
        <el-table-column
          prop="username"
          label="用户名"
          align="center"
        />
        <el-table-column
          prop="password_show"
          label="密码"
          align="center"
        />
        <el-table-column
          prop="is_ip"
          label="登录地址"
          align="center"
        />
        <el-table-column
          prop="is_up"
          label="状态"
          align="center"
        >
          <template #default="{row}">
            <el-tag
              v-if="row.is_up"
              type="success"
            >在线</el-tag>
            <el-tag
              v-else
              type="info"
            >离线</el-tag>
          </template>
        </el-table-column>
      </el-table>
    </el-scrollbar>

  </el-dialog>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import apiFun from '@/api/user.js'
const dialogVisible = ref(false)

const tableData = ref()
function getSeatsStates() {
  apiFun.seatsStates().then((res) => {
    tableData.value = res.data
  })
}

/**
 * 打开弹窗
 */
function handleOpen() {
  dialogVisible.value = true
  getSeatsStates()
}

/**
 * @param done 关闭弹窗
 */
const handleClose = (done) => {
  done()
}

/**
 * 向外面暴露方法
 */
defineExpose({ handleOpen })
</script>

<style lang="scss">
.line {
  color: red;
}
.out {
  color: gay;
}
</style>
